export const splitDateTime = (dateTimeString: string): [string, string] => {
  if (!dateTimeString) {
    return ['', ''];
  }

  // Handle ISO format like "2025-05-13T06:54:45Z"
  const parts = dateTimeString.split('T');
  if (parts.length === 2) {
    const datePart = parts[0]; // "2025-05-13"
    const timePart = parts[1].replace('Z', ''); // "06:54:45"
    return [datePart, timePart];
  }

  // Fallback if format is different (no 'T' found)
  return [dateTimeString, ''];
};
